"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertIsDefined = void 0;
const assert_1 = require("assert");
// asserts x is type doesn't work when using arrow functions
function assertIsDefined(val) {
    if (val === undefined || val === null) {
        throw new assert_1.AssertionError({ message: `Expected 'val' to be defined, but received ${val}` });
    }
}
exports.assertIsDefined = assertIsDefined;
